import * as React from 'react';
import svgSrc from 'assets/inc-500.svg';

export const Inc500 = props => (
  <figure {...props}>
    <img src={svgSrc} alt="Inc 500" />
  </figure>
);
